import VueRouter from 'vue-router'
import NotFound from '@layouts/public/NotFound'
import SentryTest from "@layouts/public/SentryTest";
import LotsList from "@layouts/public/lots/List";
import * as Sentry from "@sentry/browser";

function importErrorHandler(error) {
    console.error(error)
    Sentry.captureException(error)
    window.Vue.prototype.$eventHub.$emit('chunkError')
}

// Routes
const routes = [
    {
        path: "/",
        name: "main",
        component: LotsList,
        meta: {
            auth: undefined,
        },
    },
    {
        path: "/lots/:id",
        name: "lots.show",
        component: () => import("@layouts/public/lots/Show").catch(importErrorHandler),
        props: true,
        meta: {
            auth: undefined,
        },
    },
    {
        path: "/page/feedback",
        name: "feedback",
        props: true,
        component: () => import("@layouts/public/FeedbackPage").catch(importErrorHandler),
    },
    {
        path: "/faq",
        name: "faq",
        // props: true,
        component: () => import("@layouts/public/FaqPage").catch(importErrorHandler),
    },
    {
        path: "/page/:type",
        name: "page",
        props: true,
        component: () => import("@layouts/public/Page").catch(importErrorHandler),
        meta: {
            auth: undefined,
        },
    },
    {
        path: "/operator/users",
        name: "operator.users",
        component: () => import("@layouts/admin/users/UsersList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    {
        path: "/operator/users/:id",
        name: "operator.users.show",
        component: () => import("@layouts/admin/users/User").catch(importErrorHandler),
        props: true,
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    {
        path: "/admin/organizers",
        name: "admin.organizers",
        component: () => import("@layouts/admin/organizers/OrganizersList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    // TODO Для организатора
    {
        path: "/templates/organizers",
        name: "templates.organizers",
        component: () => import("@layouts/admin/organizers/OrganizersList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "organizer"],
            },
        },
    },
    // TODO Для организатора
    {
        path: "/templates/organizers/create",
        name: "templates.organizers.create",
        component: () => import("@layouts/admin/organizers/Create").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "organizer"],
            },
        },
    },
    // TODO Для организатора
    {
        path: "/templates/organizers/:id",
        name: "templates.organizers.show",
        component: () => import("@layouts/admin/organizers/Organizer").catch(importErrorHandler),
        props: true,
        meta: {
            auth: {
                roles: ["admin", "organizer"],
            },
        },
    },
    {
        path: "/admin/organizer-users",
        name: "admin.organizer-users",
        component: () => import("@layouts/admin/users/OrganizerUsersList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    {
        path: "/admin/organizer-users/create",
        name: "admin.organizer-users.create",
        component: () => import("@layouts/admin/users/OrganizerUserCreate").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    {
        path: "/admin/organizers/create",
        name: "admin.organizers.create",
        component: () => import("@layouts/admin/organizers/Create").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    {
        path: "/admin/organizers/:id",
        name: "admin.organizers.show",
        component: () => import("@layouts/admin/organizers/Organizer").catch(importErrorHandler),
        props: true,
        meta: {
            auth: {
                roles: ["admin", "operator","operator-buhgalter"],
            },
        },
    },
    {
        path: "/admin/lots/create",
        name: "admin-lots-create",
        component: () => import("@layouts/admin/lots/Create").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter", "organizer"],
            },
        },
    },
    {
        path: "/admin/banners",
        name: "admin-banners",
        component: () => import("@layouts/admin/banners/BannersList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin"],
            },
        },
    },
    {
        path: "/admin/tariffs",
        name: "admin.tariffs",
        component: () => import("@layouts/admin/tariffs/TariffsList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin"],
            },
        },
        props: { withNdsSetting: true }
    },
    {
        path: "/admin/account-info",
        name: "admin.account-info",
        component: () => import("@layouts/admin/accounts/AccountsInfo").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin"],
            },
        },
    },
    {
        path: "/admin/about",
        name: "admin-about",
        component: () => import("@layouts/admin/info/About").catch(importErrorHandler),
        meta: {
            auth: {
                roles: ["admin"],
            },
        },
    },
    {
        path: "/admin/lots/:id",
        name: "lots.show.admin",
        component: () => import("@layouts/admin/lots/Show").catch(importErrorHandler),
        props: true,
        meta: {
            auth: {
                roles: ["admin", "operator", "operator-buhgalter"],
            },
        },
    },
    {
        path: "/organizer/lots/:id",
        name: "lots.show.organizer",
        component: () => import("@layouts/organizer/lots/Show").catch(importErrorHandler),
        props: true,
        meta: {
            auth: {
                roles: ["organizer"],
            },
        },
    },
    {
        path: "/info",
        name: "admin-info-index",
        component: () => import("@layouts/admin/info/List").catch(importErrorHandler),
        children: [
            {
                path: "text/register_docs",
                name: "operator.editor.register_docs",
                props: () => ({
                    tips: "Здесь формируются списки документов. Каждый документ - с новой строки",
                    disableMenuBar: true,
                    tabs: [
                        { label: "Юридические лица", key: "ul_docs" },
                        { label: "Физические лица", key: "fl_docs" },
                        { label: "Индивидуальные предприниматели", key: "ip_docs" },
                    ],
                }),
                component: () => import("./components/features/Editor/TabsEditor").catch(importErrorHandler),
            },
            {
                path: "text/template_docs",
                name: "operator.editor.template_docs",
                props: true,
                component: () => import("@layouts/admin/info/DocumentsTemplate").catch(importErrorHandler),
            },
            {
                path: "text/organizer_template_docs",
                name: "operator.editor.organizer_template_docs",
                props: true,
                component: () => import("@layouts/admin/info/OrganizerDocumentsTemplate").catch(importErrorHandler),
            },
            {
                path: "text/:type",
                name: "admin-info-text",
                props: true,
                component: () => import("@layouts/admin/info/Text").catch(importErrorHandler),
            },
            {
                path: "price-plans",
                name: "admin-info-index-price-plans",
                component: () => import("@layouts/admin/info/PricePlans").catch(importErrorHandler),
            },
            {
                path: "ofd-settings",
                name: "admin.editor.ofd_settings",
                props: true,
                component: () => import('@layouts/admin/info/OfdSettings').catch(importErrorHandler),
            },
            {
                path: "faq-settings",
                name: "admin.editor.faq_settings",
                props: true,
                component: () => import('@layouts/admin/info/FaqSettings').catch(importErrorHandler),
            },
            {
                path: "faq-settings/edit/:id",
                name: "admin-editor-faqedit",
                props: true,
                component: () => import('@layouts/admin/info/FaqEditSettings').catch(importErrorHandler),
            },
            {
                path: "faq-settings/new",
                name: "admin-editor-newfaq",
                props: true,
                component: () => import('@layouts/admin/info/FaqNewSettings').catch(importErrorHandler),
            },
            {
                path: "mail-settings",
                name: "admin.editor.mail_settings",
                props: true,
                component: () => import('@layouts/admin/info/MailSettings').catch(importErrorHandler),
            },
            {
                path: "time-zones-settings",
                name: "admin.editor.time_zones_settings",
                props: true,
                component: () => import('@layouts/admin/info/TimeZonesSettings').catch(importErrorHandler),
            },

        ],
        meta: {
            auth: {
                roles: ["admin"],
            },
        },
    },
    {
        path: "/admin/messages",
        name: "admin.messages",
        component: () => import("@layouts/admin/messages/List").catch(importErrorHandler),
        children: [
            {
                path: "chat/:uid",
                name: "admin.messages.chat",
                props: route => ({
                    userId: +route.params.uid,
                    admin: true,
                }),
                component: () => import("./components/features/Chat/AdminChat").catch(importErrorHandler),
            },
        ],
        meta: {
            auth: {
                roles: ["admin", "operator","operator-buhgalter"],
            },
        },
    },
    {
        path: "/admin/operators",
        name: "operators.list",
        component: () => import("@layouts/admin/operators/OperatorsList").catch(importErrorHandler),
        meta: {
            auth: {
                roles: "admin",
            },
        },
    },
    {
        path: "/admin/operators/:id",
        name: "operators.show",
        component: () => import("@layouts/admin/operators/Operator").catch(importErrorHandler),
        props: true,
        meta: {
            auth: {
                roles: "admin",
            },
        },
    },

    //Операторы-бухгалтеры
    {
        path: "/operator-buhgalter/account-info",
        name: "operator-buhgalter.account-info",
        component: () => import("@layouts/admin/accounts/AccountsInfo").catch(importErrorHandler),
        meta: {
            auth: true,
            role: "operator-buhgalter",
        },
    },

    //Аукционы участников
    {
        path: "/user-auctions",
        name: "user-auctions-index",
        component: () => import("@layouts/user/lots/List").catch(importErrorHandler),
        meta: {
            auth: true,
            role: "user",
        },
    },
    {
        path: "/profile",
        component: () => import("@layouts/user/profile/Profile").catch(importErrorHandler),
        meta: {
            auth: true,
            role: "user",
        },
        children: [
            {
                path: "principals",
                name: "profile.principals",
                component: () => import("@features/Profile/ProfileUserPrincipalsTab").catch(importErrorHandler),
            },
            {
                path: "account",
                name: "profile.account",
                component: () => import("@features/Profile/ProfileAccount").catch(importErrorHandler),
            },
            {
                path: "messages",
                name: "profile.messages",
                component: () => import("@features/Chat/UserChat").catch(importErrorHandler),
            },
            {
                path: "",
                name: "profile.home",
                component: () => import("@features/Profile/ProfileGeneral.vue").catch(importErrorHandler),
            },
            {
                path: "change-password",
                name: "profile.change-password",
                component: () => import("@features/Users/UserChangePassword").catch(importErrorHandler),
            },
            {
                path: "commission-members",
                name: "profile.commission-members",
                component: () => import("@features/Organizers/OrganizersCommissionMembers").catch(importErrorHandler),
            },
            {
                path: "organizer-documents-template",
                name: "profile.organizer-documents-template",
                component: () => import("@layouts/admin/info/OrganizerDocumentsTemplate").catch(importErrorHandler),
            },
            {
                path: "organizer-analytics",
                name: "profile.organizer-analytics",
                component: () => import("@features/Users/UserTradingAnalyticsTab").catch(importErrorHandler),
            },
            {
                path: "organizer-profile-auctions",
                name: "profile.organizer-profile-auctions",
                component: () => import("@features/Organizers/OrganizerProfileAuctions").catch(importErrorHandler),
            },
            {
                path: "organizer-tariffs",
                name: "profile.organizer-tariffs",
                component: () => import("@layouts/admin/tariffs/TariffsList").catch(importErrorHandler),
                meta: {
                    auth: {
                        roles: ["admin", "organizer", "operator", "operator-buhgalter"],
                    },
                },
                props: { withNdsSetting: false }
            },
        ],
    },

    //Роуты для организаторов
    {
        path: "/organizer-auctions",
        name: "organizer-auctions",
        component: () => import("@layouts/organizer/lots/List").catch(importErrorHandler),
        meta: {
            auth: true,
            role: "organizer",
        },
    },

    //Общие роуты
    {
        path: "/login",
        name: "auth",
        component: () => import("@layouts/public/Auth").catch(importErrorHandler),
        meta: {
            auth: false,
        },
    },
    {
        path: "/register/accept",
        name: "register.accept",
        component: () => import("./components/features/Auth/AuthVerify").catch(importErrorHandler),
    },
    {
        path: "/auth/reset-password",
        name: "reset-password",
        component: () => import("./views/modals/RestorePassword").catch(importErrorHandler),
        meta: {
            auth: false,
        },
    },
    {
        path: "/auth/reset-password/:token",
        name: "reset-password-form",
        component: () => import("./views/modals/ResetPasswordForm").catch(importErrorHandler),
        meta: {
            auth: false,
        },
    },

    {
        path: "/logout",
        name: "logout",
        meta: {
            auth: true,
        },
    },

    {
        path: '/sentry-test',
        name: 'sentry-test',
        component: SentryTest,
    },

    {
        path: '/404',
        name: '404',
        component: NotFound,
    },

    {
        path: '*',
        redirect: '/404'
    }
];

const router = new VueRouter({
    history: true,
    mode: "history",
    routes,
});

export default router;
